import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ChartCard, DonutChart } from "@/components/Elements/Charts";
import ListStatisticsCardExtra from "@/components/ListStatistics/ListStatisticsCardExtra";
import {
  useListStatistics,
  useListDonutChartSelected,
  useLimitStatsData,
} from "@/components/ListStatistics/ListStatisticsHooks";
import { useTranslateNumber } from "@/modules/translate";

import {
  LIMIT_STAT_DATA,
  STATS_DATA_KEY,
  FILTER_KEY,
  STAT_COLORS,
} from "./constants/AssetTypeStatistics";

const AssetsTypeDonutChart = () => {
  const { t } = useTranslation();
  const { translateNumber } = useTranslateNumber();
  const othersLegend = t("global:others");

  const { loading, fetching, statsData } = useListStatistics({
    statsDataKey: STATS_DATA_KEY,
    filterKey: FILTER_KEY,
  });

  const formattedData = useLimitStatsData({
    statsData,
    limit: LIMIT_STAT_DATA,
    othersKey: othersLegend,
  });

  const chartData = useMemo(() => {
    return Object.entries(formattedData).map(([key, value], index) => ({
      name: key,
      value,
      color: key === othersLegend ? STAT_COLORS["others"] : STAT_COLORS[index],
    }));
  }, [formattedData]);

  const { selectedLegend, onLegendSelectChange } = useListDonutChartSelected({
    filterKey: FILTER_KEY,
    chartData,
  });

  const onFilterData = ({ selected }) => {
    if (selected[othersLegend] === true) {
      return;
    }

    onLegendSelectChange({ selected });
  };

  return (
    <ChartCard
      title={t("asset:statistics.type.title")}
      extra={<ListStatisticsCardExtra filterKey={FILTER_KEY} />}
    >
      <DonutChart
        data={chartData}
        loading={loading}
        fetching={fetching}
        controlled={{ selectedLegend }}
        onLegendSelectChange={onFilterData}
        formatName={(name) => name}
        formatTooltipValue={translateNumber}
      />
    </ChartCard>
  );
};

export default AssetsTypeDonutChart;
